<template>
  <div>
    <v-select
      v-model="content"
      :items="items"
      :filter="
        (item, queryText, itemText) =>
          autocompleteStatusFilter(item, queryText, itemText, statusGroup)
      "
      v-on="$listeners"
      :multiple="multiple"
      :chips="multiple"
      :hint="getStatusGroupName(statusGroup.value.key) + ' Status'"
      persistent-hint
      @change="handleInput"
    >
      <template v-slot:selection="data">
        {{ getStatusName(statusGroup.value.key, data.item) }}
      </template>
      <template v-slot:item="data">
        <v-list-item-avatar size="sm" class="mr-3">
          <v-img
            :src="
              '/media/marker/Marker_' +
                getStatusColor(statusGroup.value.key, data.item) +
                '.png'
            "
          ></v-img>
        </v-list-item-avatar>
        <v-list-item-content
          v-text="getStatusName(statusGroup.value.key, data.item)"
        ></v-list-item-content>
      </template>
    </v-select>
  </div>
</template>

<script>
import i18nDiclinaService from "../../core/services/diclina_i18n";

export default {
  name: "StatusSelect",
  props: {
    value: [Array, String],
    statusGroup: Object,
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      content: this.value
    };
  },
  computed: {
    items() {
      let keys = Object.keys(this.statusGroup.value.statusGroup.i18n.de_DE);

      for (let index in keys) {
        keys[index] = keys[index].replace("status_", "");
      }

      return keys;
    }
  },
  methods: {
    handleInput(value) {
      this.$emit("input", value);
    },

    getStatusGroupName(statusGroup) {
      return i18nDiclinaService.getDiclinaStatusGroupName(statusGroup);
    },

    getStatusName(statusGroup, status) {
      return i18nDiclinaService.getDiclinaStatusName(
        statusGroup,
        status.replace("status_", "")
      );
    },

    getStatusColor(statusGroup, status) {
      return i18nDiclinaService.getDiclinaStatusStyle(
        statusGroup,
        status.replace("status_", "")
      )?.color || "";
    },

    autocompleteStatusFilter(item, queryText, itemText, statusGroup) {
      return this.getStatusName(statusGroup.value.key, item)
        .toLowerCase()
        .includes(queryText.toLowerCase());
    },

    remove(item) {
      if (this.multiple) {
        const index = this.content.indexOf(item);
        if (index >= 0) this.content.splice(index, 1);
      } else {
        this.content = null;
      }
    }
  }
};
</script>

<style scoped></style>
